<template>
  <dv-full-screen-container>

    <!--头部开始-->
    <el-row style="height: 10%">
      <el-col :xl="24" :lg="24" :md="24" :sm="24" :sx="24" style="height: 100%">
        <div class="header">
          <div class=" header_time">
            <span class="year">{{ date }}</span>
            <span class="hour" style="margin-left: 10px">{{ time }}</span>
          </div>
          <div class="header_left_nav">
            <router-link to="/">
              <button class="butt ">首页</button>
            </router-link>
          </div>
          <div class="header_left_nav nav1" style="z-index: 100000000">
            <router-link to="/Arrondi2" >
              <button class="butt zq">文化</button>
            </router-link>
          </div>
          <div class=" nav2 " style="z-index: 100000000">
            <router-link to="/Special2" >
            <button class="butt ">咱们店</button>
            </router-link>
          </div>
          <div class=" header_title">
            <div class="header_img">
              <img src="../public/images/tixing.png" alt="">
              <div class="header_title_msg">
                金雀帮扶大数据展示系统
              </div>
            </div>
          </div>
  
          <div class=" nav3">
            <router-link to="/SpecialCoun2" >
            <button class="butt " style="width: 83px;">金雀田园</button>
            </router-link>
          </div>
          <div class=" nav5">
            <router-link to="/Traditional" >
            <button class="butt" >中药材</button>
            </router-link>
          </div>
          <div class=" nav6">
            <router-link to="/Information" >
            <button class="butt" >数据</button>
            </router-link>
          </div>

          <div class=" nav4">
            <button class="butt" v-on:click="login_out" >退出</button>
          </div>

          <div class="clear-both"></div>

        </div>

      </el-col>
    </el-row>
    <!--头部完毕-->

    <el-row style="height: 48%">

      <el-col :xl="8" :lg="8" :md="8" :sm="8" :sx="8" style="height: 100%">
        <el-col :xl="24" :lg="24" :md="24" :sm="24" :sx="24" style="height: 20%">
            <dv-border-box-10 >
              <el-card class="box-card " >
                <div class="sales_data_box">
                  <div v-for="(v,i) in sales_data" :key="i" class="text item sales_data">
                    <p class="sales_data_v">
                      <animate-number from="100" :to="v.value" :key="v.value" duration="4000"></animate-number>
                    </p>
                    <p class="sales_data_n">{{v.name}}<span>  (元)</span> </p>
                  </div>
                </div>
                <div class="clear-both"></div>
              </el-card>
            </dv-border-box-10>
          </el-col>
        <div class="clear-both"></div>

        <el-col :xl="24" :lg="24" :md="24" :sm="24" :sx="24" style=" margin-top: 2%;height: 75%">
          <dv-border-box-8 class="galleries_index">
            <el-tabs type="border-card" >
              <el-tab-pane label="各县专区消费金额" :lazy='true'>
                <div class="galleries-box" style="height: 100%; margin-top: 5%">
                  <SpecialArea style="height: 280px" msg="表格数据"/>
                </div>
              </el-tab-pane>
              <el-tab-pane label="各县专柜消费金额" :lazy='true'>
                <div class="galleries-box" style="height: 100%; margin-top: 5%">
                  <Galleries style="height: 280px" msg="表格数据"/>
                </div>
              </el-tab-pane>
              <el-tab-pane label="各县专馆消费金额" :lazy='true'>
                <div class="galleries-box" style="height: 100%; margin-top: 5%">
                  <SpecialCounter style="height: 280px" msg="表格数据"/>
                </div>
              </el-tab-pane>
            </el-tabs>
          </dv-border-box-8>
        </el-col>
        <div class="clear-both"></div>
      </el-col>

      <el-col :xl="8" :lg="8" :md="8" :sm="8" :sx="8" style="height: 100%">
        <Map msg="地图"/>
      </el-col>

      <el-col :xl="8" :lg="8" :md="8" :sm="8" :sx="8" style="height: 100%;" >
        <el-col :xl="24" :lg="24" :md="24" :sm="24" :sx="24" style="height: 20%">
          <dv-border-box-10 >
            <el-card class="box-card">
              <div class="sales_data_box">
              <div v-for="(v,i) in all_sales_data" :key="i" class="text item sales_data tang_sales_data">
                <p class="sales_data_v"><animate-number from="100" :to="v.value" :key="v.value" duration="4000"></animate-number> </p>
                <p class="sales_data_n">{{v.name}}<span>  (元)</span> </p>
              </div>
              </div>
              <div class="clear-both"></div>
            </el-card>
          </dv-border-box-10>
        </el-col>
        <el-col :xl="24" :lg="24" :md="24" :sm="24" :sx="24" style="margin-top: 2%;height: 75%;">
          <dv-border-box-8 class="galleries_index">
            <el-tabs type="border-card" class="mouth_data">
              <el-tab-pane label="专柜每月消费排行" :lazy='true'>
                <div class="galleries-box">
                  <MouthRanking2 msg="表格数据"/>
                </div>
              </el-tab-pane>
              <el-tab-pane label="专区每月消费排行" class="mouth_data_box" :lazy='true'>
                <div class="mouth_data_box1">
                  <MouthRanking1 style="height: 340px" msg="表格数据"/>
                </div>
              </el-tab-pane>
              <el-tab-pane label="专馆每月消费排行" :lazy='true'>
                <div class="galleries-box">
                  <MouthRanking3 msg="表格数据"/>
                </div>
              </el-tab-pane>
            </el-tabs>
          </dv-border-box-8>

        </el-col>
      </el-col>
    </el-row>

    <div class="clear-both"></div>

    <el-row style="height: 40%" >



      <el-col :xl="8" :lg="8" :md="8" :sm="8" :sx="8" style="margin-top: 1%;height: 100%">
        <dv-border-box-1>
          <el-tabs type="border-card" class="ranking">
            <el-tab-pane label="专区消费排行" style="height: 100%">
              <Ranking1 style="height: 84%" msg="表格数据" />
            </el-tab-pane>
            <el-tab-pane label="专柜消费排行"  style="height: 100%" :lazy='true'>
              <Ranking2 style="height: 84%" msg="表格数据"/>
            </el-tab-pane>
            <el-tab-pane label="专馆消费排行"  style="height: 100%" :lazy='true'>
              <Ranking3 style="height: 84%" msg="表格数据"/>
            </el-tab-pane>
          </el-tabs>
        </dv-border-box-1>
      </el-col>

      <el-col :xl="16" :lg="16" :md="16" :sm="16" :sx="16" style="margin-top: 1%;height: 100%; ">
        <dv-border-box-1>
          <el-tabs type="border-card" class="mess" >
            <el-tab-pane label="专区消费实时数据" style="height: 100%" :lazy='true'>
<!--              <div class="galleries-box">-->
                <Consumption1 style="height: 100%" msg="表格数据"/>
<!--              </div>-->
            </el-tab-pane>
            <el-tab-pane label="专柜消费实时数据" style="height: 100%"  :lazy='true'>
<!--              <div class="galleries-box">-->
                <Consumption2 style="height: 100%" msg="表格数据"/>
<!--              </div>-->
            </el-tab-pane>
            <el-tab-pane label="专馆消费实时数据" style="height: 100%" :lazy='true'>
<!--              <div class="galleries-box">-->
                <Consumption3 style="height: 100%" msg="表格数据"/>
<!--              </div>-->
            </el-tab-pane>
          </el-tabs>
        </dv-border-box-1>
      </el-col>

    </el-row>
    <div class="clear-both"></div>



  </dv-full-screen-container>
</template>

<script>
  import 'element-ui/lib/theme-chalk/display.css';
  import Galleries from '@/views/line_chart/Galleries.vue'
  import SpecialArea from '@/views/line_chart/SpecialArea.vue'
  import SpecialCounter from '@/views/line_chart/SpecialCounter.vue'
  import Ranking1 from '@/views/assembly/Ranking1.vue'
  import Ranking2 from '@/views/assembly/Ranking2.vue'
  import Ranking3 from '@/views/assembly/Ranking3.vue'
  import MouthRanking1 from '@/views/assembly/MouthRanking1.vue'
  import MouthRanking2 from '@/views/assembly/MouthRanking2.vue'
  import MouthRanking3 from '@/views/assembly/MouthRanking3.vue'
  import Consumption1 from '@/views/consumption/Consumption1.vue'
  import Consumption2 from '@/views/consumption/Consumption2.vue'
  import Consumption3 from '@/views/consumption/Consumption3.vue'
  import Map from '@/views/map/Map.vue'
  export default {

  name: "Index",
  components: {
    Galleries,
    SpecialArea,
    SpecialCounter,
    Ranking1,
    Ranking2,
    Ranking3,
    Map,
    MouthRanking1,
    MouthRanking2,
    MouthRanking3,
    Consumption1,
    Consumption2,
    Consumption3,
  },
  data() {
    return {
      //销售数据
      sales_data: [
          {
            name:"专区销售总额",
            value:0 ,
          },
          {
            name:"专馆销售总额",
            value:0 ,
          },
          {
            name:"专柜销售总额",
            value:0 ,
          },
      ],
      all_sales_data:[
        {
          'name':'消费扶贫产品总额',
          'value':'2190'
        },
        {
          'name':'累计消费帮扶总额',
          'value':'3001'
        }
      ],

      time:'',
      date:''
    }
  },
  created() {

    let user_id = window.localStorage.getItem('user_id');

    // if (!user_id)
    // {
    //   this.$router.push({ path: '/Login' })
    //
    //   return false;
    // }

    const data = {
      'user_id': user_id
    };

    const data1 = {
      'username': 18272924923,
      'password': 888888,
      'captcha': 123456,
    };
    this.$api.all_sales_amount(data).then(res=>{
      this.sales_data = res;

    })

    this.$api.zq_fp_summary(data).then(res=>{

      this.all_sales_data = res;
    })

    this.$api.logion(data1).then(res=>{

      this.all_sales_data = res;
    })


    const that = this;
    setInterval(updateTime, 1000);
    function updateTime() {
      const cd = new Date();
      that.time = zeroPadding(cd.getHours(), 2) + ':' + zeroPadding(cd.getMinutes(), 2) + ':' + zeroPadding(cd.getSeconds(), 2);
      that.date = zeroPadding(cd.getFullYear(), 4) + '-' + zeroPadding(cd.getMonth()+1, 2) + '-' + zeroPadding(cd.getDate(), 2);
    };

    function zeroPadding(num, digit) {
      let zero = '';
      for(let i = 0; i < digit; i++) {
        zero += '0';
      }
      return (zero + num).slice(-digit);
    }



  },

  methods: {
    login_out:function(e){
      window.localStorage.clear();
      this.$notify({
        title: '成功',
        message: '退出登录',
        type: 'success'
      });
      this.$router.push({ path: '/Login' })
    }
  }

}
</script>

<style lang="less" scoped>

@import '../public/less/index/index.less';

</style>